module.exports = __webpack_public_path__ + "img/banner.d300c585.png";